// extracted by mini-css-extract-plugin
module.exports = {"bold":"SaltPreviousCardInfo_bold__bpCT7","container":"SaltPreviousCardInfo_container__NJOO6"};